<script lang="ts" setup>
import { computed } from 'vue';
import { $fetch } from '@/home/plugins/fetch';
// import PeopleCard from '@/home/components/PeopleCard.vue';
import { useAsyncData } from '@/home/hooks/async-data';

const { data: council } = useAsyncData('about:council', () => $fetch('/committee/member/v1/list', { data: { committeeType: 1 } }))

const chairman = computed(() => {
  // 理事长组固定取 1 个
  return council.value?.filter((item: Record<string, string>) => item.weight == '2')[0];
});

const staff = computed(() => {
  return council.value?.filter((item: Record<string, string>) => item.weight == '1') ?? [];
});

const supervisor = computed(() => {
  return council.value?.filter((item: Record<string, string>) => item.weight == '3') ?? [];
});
</script>

<template>
  <section class="page-about-council pt-48px">
    <div class="about-council-container container relative pb-56px">
      <h2 class="m-0 text-center text-32px font-medium">{{ $t('about.council.title') }}</h2>
      <div class="mt-32px h-360px flex items-end" v-if="chairman">
        <div class="content h-300px w-1360px flex flex-col justify-between rounded-4px <2xl:w-1200px">
          <div class="relative h-300px w-724px py-56px pl-136px <2xl:px-56px <2xl:py-56px">
            <div class="flex leading-48px">
              <h4 class="mx-0 my-0 mb-0 text-32px text-white font-semibold">{{ chairman.name }}</h4>
              <h3 class="m-0 pl-12px text-20px text-white font-medium">{{ chairman.position }}</h3>
            </div>
            <p class="mx-0 mb-0 mt-20px h-120px overflow-x-auto whitespace-pre-wrap text-justify text-14px text-white font-semibold leading-24px">{{ chairman.resume }}</p>
          </div>
          <!-- <small class="font-medium leading-24px text-brand-gray">{{ chairman.note }}</small> -->
        </div>
        <div class="pic absolute right-144px h-360px w-240px flex-shrink-0 <2xl:right-64px">
          <img :data-src="chairman.photo" :alt="chairman.name" class="lazyload block h-full w-full object-cover">
        </div>
      </div>
      <ul class="directors mx-0 mb-0 mt-56px flex flex-wrap list-none justify-between p-0" v-if="staff.length">
        <li class="mb-56px box-border h-294px w-652px flex flex-wrap rounded-4px bg-white px-80px py-24px <2xl:w-572px <2xl:px-40px" v-for="item in staff" :key="item.id">
          <div class="mr-34px h-243px w-176px">
            <img :data-src="item.photo" :alt="item.name" class="lazyload block h-full w-full object-cover">
          </div>
          <div class="flex-1">
            <div class="mt-16px flex leading-32px">
              <h4 class="mx-0 my-0 mb-0 text-24px text-brand-normal font-semibold">{{ item.name }}</h4>
              <h3 class="m-0 pl-8px text-16px text-brand-primary font-medium">{{ item.position }}</h3>
            </div>
            <p class="m-0 mt-8px text-14px text-black font-medium leading-32px">{{ item.title }}</p>
            <p class="m-0 h-144px overflow-x-auto text-justify text-14px text-black font-normal leading-24px">
              {{ item.intro }}
            </p>
          </div>
        </li>
      </ul>
      <ul class="directors mx-0 mb-0 flex flex-wrap list-none justify-between p-0" v-if="supervisor.length">
        <li class="box-border h-294px w-652px flex flex-wrap rounded-4px bg-white px-80px py-24px <2xl:w-572px <2xl:px-40px" v-for="item in supervisor" :key="item.title">
          <div class="mr-34px h-243px w-176px">
            <img :data-src="item.photo" :alt="item.name" class="lazyload block h-full w-full object-cover">
          </div>
          <div class="flex-1">
            <div class="flex leading-32px">
              <h4 class="mx-0 my-0 mb-0 text-24px text-brand-normal font-semibold">{{ item.name }}</h4>
              <h3 class="m-0 pl-8px text-16px text-brand-primary font-medium">{{ item.position }}</h3>
            </div>
            <p class="m-0 mt-8px text-14px text-black font-medium leading-32px">{{ item.title }}</p>
            <p class="m-0 h-144px overflow-x-auto text-justify text-14px text-black font-normal leading-24px">
              {{ item.intro }}
            </p>
          </div>
        </li>
      </ul>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.page-about-council {
  .content {
    background-image: url(@/home/assets/about/director.svg);
    background-position: center;
    background-size: cover;
  }

  .directors {
    li:hover {
      box-shadow: 0 0 16px 0 rgba(0, 0, 0, 0.08);
    }
  }
}
</style>
